import { render, staticRenderFns } from "./NewPdfForm.vue?vue&type=template&id=ef68f90c&scoped=true&"
import script from "./NewPdfForm.vue?vue&type=script&lang=ts&"
export * from "./NewPdfForm.vue?vue&type=script&lang=ts&"
import style0 from "./NewPdfForm.vue?vue&type=style&index=0&id=ef68f90c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef68f90c",
  null
  
)

export default component.exports